import React from 'react';
import { Table } from 'components';
import moment from 'moment';
import { Card, Button, Input, Dropdown, DatePicker, Row, Checkbox } from 'components';
import { Modal, Form } from 'react-bootstrap';
import * as FileServer from 'file-saver';
import * as XLSX from 'xlsx';
import { currencyFormatter } from 'services/helpers';

const Body = ({ _this }) => {
  const formatStatus = (status) => {
    return status.replaceAll('_', ' ').toUpperCase();
  };
  const exportReport = () => {
    const extractedDataArray = [];
    for (const dataObject of _this.tableData) {
      const name = dataObject.name;
      const email = dataObject.email;
      const phone = dataObject.phone;
      const description = dataObject.description;
      const amount = currencyFormatter.format(dataObject.amount);
      const status = formatStatus(dataObject.status);

      const extractedData = {
        Name: name,
        Email: email,
        Phone: phone,
        Description: description,
        Amount: amount,
        Status: status
      };

      extractedDataArray.push(extractedData);
    }
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(extractedDataArray);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Create a Blob and save the Excel file
    const data = new Blob([excelBuffer], { type: fileType });
    FileServer.saveAs(data, 'VegasConferenceIncompletePaymentsReport' + fileExtension);
  };
  const columns = [
    {
      fixed: 'left',
      headerStyle: { backgroundColor: '#474747', fontSize: '90%' },
      style: { backgroundColor: '#C6C6C6' },
      accessor: 'name',
      Header: 'Name',
      Cell: (row) => <div>{row.original.name}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Email',
      accessor: 'email',
      Cell: (row) => <div>{row.original.email}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Phone',
      accessor: 'phone',
      Cell: (row) => <div>{row.original.phone}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Description',
      accessor: 'description',
      Cell: (row) => <div>{row.original.description}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Amount',
      accessor: 'amount',
      Cell: (row) => <div>{currencyFormatter.format(row.original.amount)}</div>
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Status',
      accessor: 'status',
      Cell: (row) => {
        // const formatStatus = (status) => {
        //   return status
        //     .split('_')
        //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        //     .join(' ');
        // };

        return <div className="text-red-700">{formatStatus(row.original.status)}</div>;
      }
    },
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Send Mail',
      accessor: 'send_mail',
      Cell: (row) => (
        <div className="w-full flex justify-center items-center p-2">
          <div className="w-20">
            <Button onClick={() => _this.sendIndividualMail(row.original.paymentIntentId)}>
              Send Mail
            </Button>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="flex flex-col gap-1">
      <Card background={'bg-cardbg1'} className="">
        <div className="relative flex flex-col sm:flex-row gap-2 justify-between items-center flex-wrap">
          <h3 className="text-body-color text-xl md:text-2xl">
            Vegas Conference Incomplete Payments Report ({_this.tableData.length})
          </h3>
          <div className="w-42">
            <Button onClick={_this.init}>Generate Report</Button>
          </div>
          <input
            className="w-64 rounded-md"
            type="search"
            placeholder="Search.."
            value={_this.searchInput}
            onChange={(e) => _this.setSearchInput(e.target.value)}
          />

          <div className="w-42">
            <Button onClick={_this.sendMailToAll}>Send Mail to All</Button>
          </div>

          <div className="w-28">
            <Button onClick={exportReport}>Export</Button>
          </div>
        </div>
      </Card>
      <Table
        keyField="id"
        columns={columns}
        data={_this.tableData}
        headerComponent={null}
        minRows={20}
      />
    </div>
  );
};

export default Body;
